var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmyGoodConduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    width: 30,
    height: 250,
    fill: "#520F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 290,
    height: 250,
    fill: "#520F1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmyGoodConduct);
export default __webpack_public_path__ + "static/media/Army Good Conduct.f1c5d341a58869534c5c7e6f392e8546.svg";
export { ForwardRef as ReactComponent };